"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const Container_1 = __importDefault(require("@material-ui/core/Container"));
const stateFunctions_1 = require("../../domain/stateFunctions");
const chatFunctions = __importStar(require("../../domain/model/chats"));
const replyToMessage_1 = require("../../actions/chats/replyToMessage");
const CloseButton_1 = __importDefault(require("../shared/CloseButton"));
const MessageReplyPanel_1 = __importDefault(require("./MessageReplyPanel"));
exports.default = react_1.default.memo(ReplyToMessagePanel);
const useStyles = makeStyles_1.default((theme) => ({
    container: {
        paddingLeft: 16,
        paddingRight: 16,
    },
    innerContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 8
    },
    contentContainer: {
        maxWidth: 500,
        [theme.breakpoints.down('sm')]: {
            maxWidth: "87vw"
        },
        backgroundColor: colorManipulator_1.darken(theme.colors.messageSentByElse.highlightedContentBackgroundColor, 0.05),
        borderRadius: 6,
        "& svg": {
            opacity: 0.7
        }
    },
    closeButton: {
        marginLeft: 16
    }
}));
function ReplyToMessagePanel() {
    const dispatch = react_redux_1.useDispatch();
    const classes = useStyles();
    const chat = react_redux_1.useSelector((state) => stateFunctions_1.getSelectedChat(state.chatsState));
    const myUserId = react_redux_1.useSelector((state) => state.usersState.me.userId);
    const userMap = react_redux_1.useSelector((state) => state.usersState.userDictionary);
    const replyContext = chat === null || chat === void 0 ? void 0 : chat.replyContext;
    let panel = null;
    if (chat && replyContext) {
        const repliesToMyMessage = myUserId === replyContext.userId;
        const repliesToUsername = !repliesToMyMessage && userMap.hasOwnProperty(replyContext.userId)
            ? userMap[replyContext.userId].username
            : null;
        let theirUsername;
        if (chatFunctions.isDirectChat(chat)) {
            theirUsername = userMap.hasOwnProperty(chat.them)
                ? userMap[chat.them].username
                : null;
        }
        panel =
            react_1.default.createElement("div", { className: classes.innerContainer },
                react_1.default.createElement(MessageReplyPanel_1.default, { repliesToChatId: replyContext.chatId, isPrivateReply: chat.chatId !== replyContext.chatId, content: replyContext.content, repliesToMyMessage: repliesToMyMessage, sentByMe: false, isGroupChat: chatFunctions.isGroupChat(chat), theirUsername: theirUsername, repliesToUsername: repliesToUsername, className: classes.contentContainer }),
                react_1.default.createElement(CloseButton_1.default, { className: classes.closeButton, onClick: closePanel }));
    }
    function closePanel() {
        dispatch(replyToMessage_1.cancelReplyToMessage(chat.chatId));
    }
    return (react_1.default.createElement(Container_1.default, { className: classes.container }, panel));
}
